export default __webpack_public_path__ + "static/media/estudo.2138d6ed.png";